import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { SocialMediaShareLinkService } from '@rma/generic/ui/share-modal';

@Component({
  selector: 'rma-blog-social-share-button',
  templateUrl: './post-share-button.component.html',
  styleUrls: ['./post-share-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, RmaIconComponent],
})
export class PostShareButtonComponent {
  @Input()
  public slug: string;

  constructor(private readonly shareLinkService: SocialMediaShareLinkService) {}

  public shareOnFacebook($event: Event): void {
    this.preventDefault($event);

    this.slug = this.slug?.trim();
    if (!this.slug) {
      return;
    }

    this.shareLinkService.shareOnFacebook(`/blog/post/${this.slug}`);
  }

  public shareOnTwitter($event: Event): void {
    this.preventDefault($event);

    this.slug = this.slug?.trim();
    if (!this.slug) {
      return;
    }

    this.shareLinkService.shareOnTwitter(`/blog/post/${this.slug}`);
  }

  public shareOnLinkedIn($event: Event): void {
    this.preventDefault($event);

    this.slug = this.slug?.trim();
    if (!this.slug) {
      return;
    }

    this.shareLinkService.shareOnLinkedin(`/blog/post/${this.slug}`);
  }

  private preventDefault($event: Event) {
    $event?.preventDefault();
    $event?.stopPropagation();
  }
}
